import Head from 'next/head'
import Header from '@/features/Header';
import MainLayout from '@/shared/layouts/MainLayout';
import NotFoundPage from "@/shared/layouts/NotFoundPage";

export default function NotFound() {

  return (
    <>
      <Head>
        <title>Hiveon Business Portal</title>
        <meta name="description" content="" />
      </Head>
      <div className="flex flex-col h-screen">
        <Header/>
        <MainLayout className="grow flex items-center justify-center">
          <NotFoundPage />
        </MainLayout>
      </div>
    </>
  );
}
